import React from 'react'

const Footer = () => {
  return (
  <footer>
    <div>
<h1>IT Solution</h1>
<p>@all reserved </p>
    </div>
    <div>
        <h4> Follow us</h4>
            <a href="/https:instagram.com">Instagram</a>
            <a href="/https:instagram.com">Facebook</a>
            <a href="/https:instagram.com">LinkedIn</a>
    </div>
  </footer>
  )
}

export default Footer
